import { Types } from './types'

const initialState = {

    dataSetting: {
        paging: {},
        rows: [],
    },
    dataPopup: {
        paging: {},
        rows: [],
    },

    dataScreenBanner: {
        paging: {},
        rows: [],
    },

    dataBannerHomepage: {
        paging: {},
        rows: [],
    }
}
const reducer = (state = initialState, action) => {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case Types.SAVE_LIST_POPUP:
            return {
                ...newState,
                dataPopup: action.payload
            }
        case Types.SAVE_SETTING:
            return {
                ...newState,
                dataSetting: action.payload
            }
        case Types.SAVE_LIST_SCREEN_BANNER:
            return {
                ...newState,
                dataScreenBanner: action.payload
            }
        case Types.SAVE_LIST_BANNER_HOMEPAGE:
            return {
                ...newState,
                dataBannerHomepage: action.payload
            }

        default:
            return { ...newState }
    }
}
export default reducer
